import { RAG_COLORS } from "../DashboardPage/constants";

export const DEFAULT_ORDER_LIST_LIMIT = 10;
export const DEFAULT_PHARMACY_LIST_LIMIT = 10;
export const LIMIT_OPTIONS = [5, 10, 20, 50];

export const PHARMACY_TYPES = {
  OTC: 'otc',
  PDP: 'paid_delivery',
  ODPP: 'delivery'
};

export const TABS = {
  ALL: 'all',
  REQUESTED: 'requested',
  PROCESSING: 'processing',
  READY: 'ready'
};

export const ORDER_TYPES = {
  REFERRED: 'referred'
};

const NEW_RED='new_red'
const PROCESSING_RED='processing_red'
const PROCESSING_AMBER='processing_amber'

export const ORDER_TYPE_UI = {
  [NEW_RED]: {
    color: RAG_COLORS.red,
    status: 'New',
  },
  [PROCESSING_RED]: {
    color: RAG_COLORS.red,
    status: 'Processing',
  },
  [PROCESSING_AMBER]: {
    color: RAG_COLORS.amber,
    status: 'Processing',
  },
};